/* AlienGuards V3 motion layer (~3 KB). No libraries. Respects prefers-reduced-motion. */
(function () {
  var d = document, root = d.documentElement;
  if (!('IntersectionObserver' in window)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };

  /* Everything starts only after the first frame has painted, and the heavier
     setup waits for window load + idle time, so the motion layer never competes
     with first paint, the LCP image or the product builder. */
  var booted = 0, boot = function () {
    if (booted) return; booted = 1;
    root.classList.add('ag-fx');
  /* 1. live toggling: loops run only while their block is on screen */
  var liveSel = '.ag-hero,.ag-strip--mq,.ag-lineup,.ag-cgrid,.ag-gx,.ag-footer,.ag-gallery,.ag-gallery__main,.ag-why,.ag-cbanner,.ag-has-stars,.ag-builder,.ag-404,.ag-designs';
  liveIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('is-live', e.isIntersecting); });
  }, { rootMargin: '80px 0px' });

  $$(liveSel).forEach(function (el) { liveIO.observe(el); });
  $$('.ag-footer__big').forEach(function (el) { el.setAttribute('data-ag-text', el.textContent.trim()); });
  /* 4. hero: decode the eyebrow, and place the scan sweep exactly over the photo frame */
  $$('.ag-hero .ag-eyebrow, .ag-phero .ag-eyebrow').forEach(function (el) {
    var txt = el.textContent, glyph = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789#%&*+/<>', f = 0, total = 22;
    if (!txt || txt.length > 60) return;
    el.style.height = el.offsetHeight + 'px'; el.style.overflow = 'hidden';
    (function tick() {
      f++;
      var reveal = Math.floor(txt.length * f / total), out = '';
      for (var i = 0; i < txt.length; i++) out += (i < reveal || txt[i] === ' ' || txt[i] === '-') ? txt[i] : glyph[(Math.random() * glyph.length) | 0];
      el.textContent = out;
      if (f < total) requestAnimationFrame(tick); else { el.textContent = txt; el.style.height = ''; el.style.overflow = ''; }
    })();
  });
  var hero = d.querySelector('.ag-hero .ag-hero__media'), himg = hero && hero.querySelector('img');
  if (hero && himg) {
    var scan = d.createElement('span'); scan.className = 'ag-scan'; scan.setAttribute('aria-hidden', 'true'); hero.appendChild(scan);
    var place = function () {
      var src = himg.currentSrc || himg.src || '';
      if (src.indexOf('ag-v5-hero') < 0) { scan.classList.remove('is-on'); return; }
      var mob = src.indexOf('hero-mobile') > -1;
      var nw = mob ? 1080 : 2400, nh = mob ? 1080 : 1350;
      var fr = mob ? [330, 63, 1000, 1018] : [1422, 150, 2157, 1227];
      var w = himg.clientWidth, h = himg.clientHeight; if (!w || !h) return;
      var s = Math.max(w / nw, h / nh), dw = nw * s, dh = nh * s;
      var pos = (getComputedStyle(himg).objectPosition || '50% 50%').split(' ');
      var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || '50') / 100;
      if (isNaN(px)) px = 0.5; if (isNaN(py)) py = 0.5;
      var ox = (w - dw) * px + himg.offsetLeft, oy = (h - dh) * py + himg.offsetTop;
      scan.style.left = (ox + fr[0] * s) + 'px'; scan.style.top = (oy + fr[1] * s) + 'px';
      scan.style.width = ((fr[2] - fr[0]) * s) + 'px'; scan.style.height = ((fr[3] - fr[1]) * s) + 'px';
      scan.style.borderRadius = (28 * s) + 'px';
      scan.classList.add('is-on');
    };
    if (himg.complete) place(); else himg.addEventListener('load', place);
    if ('ResizeObserver' in window) new ResizeObserver(function () { place(); }).observe(himg);
    else { var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(place, 150); }); }
  }

  };
  var late = function () {
  /* 2. starfield in dark sections */
  $$('.ag-sec--alt,.ag-gx,.ag-footer,.ag-phero,.ag-cbanner,.ag-404').forEach(function (s) {
    if (s.querySelector(':scope > .ag-stars')) return;
    var st = d.createElement('span'); st.className = 'ag-stars'; st.setAttribute('aria-hidden', 'true');
    s.classList.add('ag-has-stars'); s.insertBefore(st, s.firstChild);
  });

  $$('.ag-has-stars').forEach(function (el) { liveIO.observe(el); });
  /* feature icons: glow pulse only while visible */
  var icIO = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-live', e.isIntersecting); }); });
  $$('.ag-ic--art').forEach(function (el) { icIO.observe(el); });
  /* 3. scroll reveal with stagger; only for elements below the first viewport (no flash, no LCP impact) */
  var rvSel = ['.ag-sec-head', '.ag-lineup > .ag-card', '.ag-cgrid > *', '.ag-step', '.ag-pillar', '.ag-why .ag-photo', '.ag-sport',
    '.ag-community > *', '.ag-reviews', '.ag-teams', '.ag-tile', '.ag-stat', '.ag-faq__cat', '.ag-faq details', '.ag-designs__item',
    '.ag-split > *', '.ag-compare-wrap', '.ag-gx__seal', '.ag-gx__copy > .ag-eyebrow', '.ag-gx__copy > .ag-h2', '.ag-gx__lead', '.ag-gx__pt',
    '.ag-gx__ctas', '.ag-footer__cols > *', '.ag-lead__box', '.ag-cta .ag-wrap > *', '.ag-accs', '.ag-feats2 > *', '.ag-prose > *',
    '.cart-item', '#product-grid > li', '.ag-404__inner > *'].join(',');
  var vh = window.innerHeight;
  var rvIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = e.target; rvIO.unobserve(t); t.classList.add('is-in');
      setTimeout(function () { t.classList.remove('ag-rv', 'is-in', 'ag-rv--scale'); t.style.removeProperty('--d'); }, 1400);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
  var counts = new Map();
  $$(rvSel).forEach(function (el) {
    if (el.closest('.ag-rv') || el.closest('.ag-acc__body,.ag-builder,[data-ag-options]')) return;
    var r = el.getBoundingClientRect();
    if (r.top < vh * 0.95 || r.height === 0) return;
    var p = el.parentNode, n = counts.get(p) || 0; counts.set(p, n + 1);
    el.style.setProperty('--d', (Math.min(n, 6) * 0.08) + 's');
    el.classList.add('ag-rv');
    if (el.matches('.ag-card,.ag-sport,.ag-gx__seal,.ag-designs__item')) el.classList.add('ag-rv--scale');
    rvIO.observe(el);
  });

  /* 5. hover tilt on cards (fine pointers only) */
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('.ag-card,.ag-sport,.ag-tile,.ag-step').forEach(function (c) {
      var raf = 0;
      c.addEventListener('pointermove', function (e) {
        if (c.classList.contains('ag-rv')) return;
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          c.classList.add('ag-tilt'); c.style.setProperty('--ry', (x * 7).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
        });
      });
      c.addEventListener('pointerleave', function () { cancelAnimationFrame(raf); c.classList.remove('ag-tilt'); c.style.removeProperty('--rx'); c.style.removeProperty('--ry'); });
    });
  }

  /* 6. builder: progress glow line follows the selected step */
  var syncTabs = function (tabs) {
    var all = $$('.ag-tab', tabs), i = all.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
    tabs.style.setProperty('--ag-p', ((i + 1) / Math.max(all.length, 1)).toFixed(3));
  };
  var hookTabs = function () {
    $$('.ag-tabs').forEach(function (tabs) {
      if (tabs.__agfx) return; tabs.__agfx = 1; syncTabs(tabs);
      new MutationObserver(function () { syncTabs(tabs); }).observe(tabs, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
    });
  };
    hookTabs();
    /* 7. 3D alien head: fetch the tiny WebGL viewer + model only when the seal nears the viewport */
    var h3 = d.querySelector('[data-ag3d-js]');
    if (h3 && !(navigator.connection && navigator.connection.saveData)) {
      var io3 = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io3.disconnect();
        var sc = d.createElement('script'); sc.src = h3.getAttribute('data-ag3d-js'); sc.async = true; d.head.appendChild(sc);
      }, { rootMargin: '400px 0px' });
      io3.observe(h3);
    }
  };
  var liveIO;
  /* The motion stylesheet is fetched only after the first frame has painted, so it can never delay first paint or LCP. */
  var cssHref = (d.currentScript && d.currentScript.getAttribute('data-css')) || '';
  var loadCss = function (cb) {
    if (!cssHref || d.querySelector('link[data-ag-fx]')) return cb();
    var l = d.createElement('link'); l.rel = 'stylesheet'; l.href = cssHref; l.setAttribute('data-ag-fx', '');
    l.onload = l.onerror = function () { cb(); }; d.head.appendChild(l);
  };
  var idle = function (fn) { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(fn, { timeout: 1500 }); };
  /* start only once the browser has actually painted content (or after 3 s as a safety net) */
  var cssReady = 0, winLoaded = 0, lateDone = 0;
  var maybeLate = function () { if (cssReady && winLoaded && !lateDone) { lateDone = 1; idle(late); } };
  var started = 0, start = function () { if (started) return; started = 1; idle(function () { loadCss(function () { boot(); cssReady = 1; maybeLate(); }); }); };
  var afterPaint = function () {
    try {
      if (performance.getEntriesByName('first-contentful-paint').length) return start();
      new PerformanceObserver(function (l, o) { if (l.getEntriesByName('first-contentful-paint').length) { o.disconnect(); start(); } }).observe({ type: 'paint', buffered: true });
    } catch (e) { requestAnimationFrame(function () { setTimeout(start, 0); }); }
    setTimeout(start, 3000);
  };
  var onLoad = function () { winLoaded = 1; maybeLate(); };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', afterPaint); else afterPaint();
  if (d.readyState === 'complete') onLoad(); else window.addEventListener('load', onLoad);
})();
